import React from "react";
import webdev from "../images/webdev.gif";
import AndroidDev from "../images/AndroidDev.gif";
import dataScience from "../images/dataScience.webp";
import javaP from "../images/javaP.avif";
import python from "../images/python.avif";
import cpp from "../images/cpp.avif";
import ml from "../images/ml.gif";
import ux from "../images/ux.gif";

function CoursesSection() {
  return (
    <>
      <div className="bg-white" id="allDomain">
        <div className="mx-auto max-w-2xl px-4 py-4 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8 ">
          <h2 className="text-4xl py-3 text-center font-bold tracking-tight text-gray-900">
            Internship Positions
          </h2>
          <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
            <div className="group relative">
              <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-md bg-gray-200 lg:aspect-none group-hover:opacity-75 lg:h-80">
                <img
                  src={webdev}
                  alt="Front of men's Basic Tee in black."
                  className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                />
              </div>
              <div className="mt-4 flex justify-between">
                <div>
                  <h3 className="text-2xl text-center  text-gray-700">
                    <a href="/Applynow.jsx">
                      <span aria-hidden="true" className="absolute inset-0" />
                      Web Development
                    </a>
                  </h3>
                  <p className="mt-1 text-sm text-gray-500 text-center ">
                    web development internship that provides practical work
                    experience and an introduction to crafting and enhancing
                    web-based systems. This opportunity offers engaging
                    challenges and real-world projects, allowing you to gain
                    hands-on experience in the dynamic fields of web and app
                    development. Join our award-winning innovation team and
                    kickstart your journey to success in a supportive and
                    enriching environment.<br></br>
                    <br></br>
                    <a
                      href="/Applynow.jsx"
                      rel="noreferrer"
                      target="_blank"
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    >
                      Apply
                    </a>
                  </p>
                </div>
                {/* <p className="text-sm font-medium text-gray-900">$35</p> */}
              </div>
            </div>
            {/* More products... */}
            <div className="group relative">
              <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-md bg-gray-200 lg:aspect-none group-hover:opacity-75 lg:h-80">
                <img
                  src={AndroidDev}
                  alt="Front of men's Basic Tee in black."
                  className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                />
              </div>
              <div className="mt-4 flex justify-between">
                <div>
                  <h3 className="text-2xl text-center  text-gray-700">
                    <a href="/Applynow.jsx">
                      <span aria-hidden="true" className="absolute inset-0" />
                      Android Development
                    </a>
                  </h3>
                  <p className="mt-1 text-sm text-gray-500 text-center ">
                    Android, the user-friendly open-source operating system, has
                    transformed the way we access internet applications and
                    carry out important tasks on our mobile. At CurioCode , we
                    understand the growing preference for mobile usage and offer
                    the ideal starting point for your development journey.
                    Discover the simplicity of creating your first app with us
                    and unlock a world of endless possibilities in the realm of
                    mobile innovation.<br></br>
                    <br></br>
                    <a
                      href="/Applynow.jsx"
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    >
                      Apply
                    </a>
                  </p>
                </div>
                {/* <p className="text-sm font-medium text-gray-900">$35</p> */}
              </div>
            </div>

            <div className="group relative">
              <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-md bg-gray-200 lg:aspect-none group-hover:opacity-75 lg:h-80">
                <img
                  src={dataScience}
                  alt="Front of men's Basic Tee in black."
                  className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                />
              </div>
              <div className="mt-4 flex justify-between">
                <div>
                  <h3 className="text-2xl text-center  text-gray-700">
                    <a href="/Applynow.jsx">
                      <span aria-hidden="true" className="absolute inset-0" />
                      Data Science
                    </a>
                  </h3>
                  <p className="mt-1 text-sm text-gray-500 text-center ">
                    Android, the user-friendly open-source operating system, has
                    transformed the way we access internet applications and
                    carry out important tasks on our mobile. At CurioCode , we
                    understand the growing preference for mobile usage and offer
                    the ideal starting point for your development journey.
                    Discover the simplicity of creating your first app with us
                    and unlock a world of endless possibilities in the realm of
                    mobile innovation.<br></br>
                    <br></br>
                    <a
                      href="/Applynow.jsx"
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    >
                      Apply
                    </a>
                  </p>
                </div>
                {/* <p className="text-sm font-medium text-gray-900">$35</p> */}
              </div>
            </div>

            <div className="group relative">
              <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-md bg-gray-200 lg:aspect-none group-hover:opacity-75 lg:h-80">
                <img
                  src={javaP}
                  alt="Front of men's Basic Tee in black."
                  className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                />
              </div>
              <div className="mt-4 flex justify-between">
                <div>
                  <h3 className="text-2xl text-center  text-gray-700">
                    <a href="/Applynow.jsx">
                      <span aria-hidden="true" className="absolute inset-0" />
                      Java Programming
                    </a>
                  </h3>
                  <p className="mt-1 text-sm text-gray-500 text-center ">
                    Become a Java programming master from the convenience of
                    your own home and unlock incredible job prospects with our
                    certification program. Join our comprehensive 4-week
                    internship program, where you'll learn everything from web
                    application development to deployment using Java Build a
                    solid foundation for your career with hands-on training and
                    real-world application in a supportive and collaborative
                    environment.<br></br>
                    <br></br>
                    <a
                      href="/Applynow.jsx"
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    >
                      Apply
                    </a>
                  </p>
                </div>
                {/* <p className="text-sm font-medium text-gray-900">$35</p> */}
              </div>
            </div>

            <div className="group relative">
              <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-md bg-gray-200 lg:aspect-none group-hover:opacity-75 lg:h-80">
                <img
                  src={cpp}
                  alt="Front of men's Basic Tee in black."
                  className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                />
              </div>
              <div className="mt-4 flex justify-between">
                <div>
                  <h3 className="text-2xl text-center  text-gray-700">
                    <a href="/Applynow.jsx">
                      <span aria-hidden="true" className="absolute inset-0" />
                      C++ Programming
                    </a>
                  </h3>
                  <p className="mt-1 text-sm text-gray-500 text-center ">
                    Gain mastery in C++ programming from the comfort of your
                    home and open doors to amazing job opportunities with our
                    certification program. Enroll in our intensive 4-week
                    internship, where you'll acquire knowledge in web
                    application development and deployment using C++. Establish
                    a strong base for your career and real-world implementation
                    within a supportive and collaborative setting.<br></br>
                    <br></br>
                    <a
                      href="/Applynow.jsx"
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    >
                      Apply
                    </a>
                  </p>
                </div>
                {/* <p className="text-sm font-medium text-gray-900">$35</p> */}
              </div>
            </div>

            <div className="group relative">
              <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-md bg-gray-200 lg:aspect-none group-hover:opacity-75 lg:h-80">
                <img
                  src={python}
                  alt="Front of men's Basic Tee in black."
                  className="pythonImage object-center lg:h-full lg:w-full"
                />
              </div>
              <div className="mt-4 flex justify-between">
                <div>
                  <h3 className="text-2xl text-center  text-gray-700">
                    <a href="/Applynow.jsx">
                      <span aria-hidden="true" className="absolute inset-0" />
                      Python Programming
                    </a>
                  </h3>
                  <p className="mt-1 text-sm text-gray-500 text-center ">
                    Join our 4-week comprehensive internship program and master
                    the fundamentals of programming in Python from the comfort
                    of your own home. In this program, you will learn everything
                    from web development to the deployment of Python-based web
                    applications. Get certified and enhance your career
                    prospects. Don't miss this opportunity to excel in Python
                    programming!<br></br>
                    <br></br>
                    <a
                      href="/Applynow.jsx"
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    >
                      Apply
                    </a>
                  </p>
                </div>
                {/* <p className="text-sm font-medium text-gray-900">$35</p> */}
              </div>
            </div>

            <div className="group relative">
              <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-md bg-gray-200 lg:aspect-none group-hover:opacity-75 lg:h-80">
                <img
                  src={ux}
                  alt="Front of men's Basic Tee in black."
                  className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                />
              </div>
              <div className="mt-4 flex justify-between">
                <div>
                  <h3 className="text-2xl text-center  text-gray-700">
                    <a href="/Applynow.jsx">
                      <span aria-hidden="true" className="absolute inset-0" />
                      UI/UX Design
                    </a>
                  </h3>
                  <p className="mt-1 text-sm text-gray-500 text-center ">
                    Gain mastery in UI/UX Design from the comfort of your home
                    and open doors to amazing job opportunities with our
                    certification program. Enroll in our intensive 4-week
                    internship, where you'll acquire knowledge in web
                    application development and deployment . Establish a strong
                    base for your career and real-world implementation within a
                    supportive and collaborative setting.<br></br>
                    <br></br>
                    <a
                      href="/Applynow.jsx"
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    >
                      Apply
                    </a>
                  </p>
                </div>
                {/* <p className="text-sm font-medium text-gray-900">$35</p> */}
              </div>
            </div>

            <div className="group relative">
              <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-md bg-black-100 lg:aspect-none group-hover:opacity-75 lg:h-80">
                <img
                  src={ml}
                  alt="Front of men's Basic Tee in black."
                  className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                />
              </div>
              <div className="mt-4 flex justify-between">
                <div>
                  <h3 className="text-2xl text-center  text-gray-700">
                    <a href="/Applynow.jsx">
                      <span aria-hidden="true" className="absolute inset-0" />
                      Artificial intelligence
                    </a>
                  </h3>
                  <p className="mt-1 text-sm text-gray-500 text-center ">
                    Gain mastery in Artificial intelligence from the comfort of
                    your home and open doors to amazing job opportunities with
                    our certification program. Enroll in our intensive 4-week
                    internship, where you'll acquire knowledge in web
                    application development and deployment . Establish a strong
                    base for your career and real-world implementation within a
                    supportive and collaborative setting.<br></br>
                    <br></br>
                    <a
                      href="/Applynow.jsx"
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    >
                      Apply
                    </a>
                  </p>
                </div>
                {/* <p className="text-sm font-medium text-gray-900">$35</p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CoursesSection;
